import { forwardRef } from "react";
import PropTypes from "prop-types";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import { FormSelect } from "../FormSelect";

const countryCodeOptions = getCountries().map((country) => {
  const code = getCountryCallingCode(country);

  return {
    text: `${country} +${code}`,
    value: country,
  };
});

export const FormCountryCodeSelect = forwardRef(
  (
    {
      "aria-describedby": ariaDescribedBy = undefined,
      className = "",
      id = undefined,
      isDisabled = false,
      isOptional = false,
      label = undefined,
      name,
      onChange = () => {},
    },
    ref
  ) => {
    return (
      <FormSelect
        ref={ref}
        aria-describedby={ariaDescribedBy}
        className={className}
        id={id}
        isDisabled={isDisabled}
        isOptional={isOptional}
        label={label}
        name={name}
        onChange={onChange}
        options={countryCodeOptions}
      />
    );
  }
);

FormCountryCodeSelect.displayName = "FormCountryCodeSelect";

FormCountryCodeSelect.propTypes = {
  "aria-describedby": PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
  isDisabled: PropTypes.bool,
  isOptional: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};
